const tools = [
  {
    title: 'Expert Kredytowy',
    path: '/doradca360',
    desc: 'Kompleksowa analiza finansowa 360° — analiza, dobór ofert, negocjacje z bankami. Wszystko w jednym miejscu, bez chodzenia po placówkach.',
    icon: 'ri-compass-3-line',
    color: 'bg-primary-500',
    badge: 'Nowość',
  },
  {
    title: 'Kalkulator nadpłaty',
    path: '/narzedzia/nadplata-kredytu',
    desc: 'Sprawdź ile lat i tysięcy złotych zaoszczędzisz nadpłacając kredyt. Symulacja z wykresem salda dla nadpłat miesięcznych i jednorazowych.',
    icon: 'ri-arrow-down-circle-line',
    color: 'bg-green-600',
    badge: null,
  },
  {
    title: 'Kalkulator refinansowania',
    path: '/narzedzia/refinansowanie',
    desc: 'Porównaj obecną ratę z ratą po refinansowaniu. Zobacz oszczędność miesięczną, roczną i czas zwrotu kosztów przeniesienia.',
    icon: 'ri-exchange-dollar-line',
    color: 'bg-accent-500',
    badge: null,
  },
  {
    title: 'Kalkulator zdolności',
    path: '/narzedzia/zdolnosc-kredytowa',
    desc: 'Oszacuj, ile kredytu możesz dostać. Uwzględnia dochody, zobowiązania, koszty utrzymania i bufor stóp KNF (+2,5 p.p.).',
    icon: 'ri-scales-3-line',
    color: 'bg-secondary-500',
    badge: null,
  },
  {
    title: 'Kalkulator kredytu firmowego',
    path: '/narzedzia/kredyt-firmowy',
    desc: 'Policz ratę kredytu obrotowego lub inwestycyjnego dla firmy i sprawdź zdolność wskaźnikiem DSCR. Symulacja z oceną bankową.',
    icon: 'ri-briefcase-line',
    color: 'bg-secondary-500',
    badge: 'Dla firm',
  },
  {
    title: 'Leasing vs kredyt',
    path: '/narzedzia/leasing-vs-kredyt',
    desc: 'Porównaj leasing operacyjny z kredytem firmowym z uwzględnieniem tarczy podatkowej. Zobacz, która forma finansowania jest tańsza.',
    icon: 'ri-arrow-left-right-line',
    color: 'bg-accent-500',
    badge: 'Dla firm',
  },
  {
    title: 'Kalkulator konsolidacji',
    path: '/narzedzia/konsolidacja',
    desc: 'Połącz kredyty, karty i raty w jeden kredyt. Zobacz, ile zyskasz na miesięcznej racie i czy konsolidacja się opłaca w Twoim przypadku.',
    icon: 'ri-stack-line',
    color: 'bg-primary-500',
    badge: null,
  },
];

export default function ToolsHub() {
  return (
    <div>
      {/* Hero */}
      <section className="bg-foreground-950 text-white py-14 md:py-20">
        <div className="mx-auto max-w-[1440px] px-4 text-center md:px-8 lg:px-16 xl:px-20">
          <div className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-primary-400 opacity-0 animate-slide-up animation-delay-100">
            Narzędzia finansowe
          </div>
          <h1 className="mx-auto mb-4 max-w-2xl font-heading text-2xl font-bold leading-tight text-white opacity-0 animate-slide-up animation-delay-200 md:text-3xl lg:text-4xl">
            Darmowe kalkulatory kredytowe — policz samodzielnie przed rozmową z bankiem
          </h1>
          <p className="mx-auto max-w-xl text-sm leading-relaxed text-white/60 opacity-0 animate-slide-up animation-delay-300 md:text-base">
            Wszystkie narzędzia oparte na realnych algorytmach bankowych. Wyniki mają charakter poglądowy, ale dają solidne wyobrażenie o Twoich możliwościach.
          </p>
        </div>
      </section>

      {/* Tools Grid */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
          <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-5 md:grid-cols-2">
            {tools.map((tool, i) => (
              <a
                key={tool.path}
                href={tool.path}
                className="group text-left bg-white rounded-2xl border border-background-200 p-6 md:p-7 shadow-sm hover:shadow-md hover:border-primary-200 transition-all cursor-pointer"
                style={{ animationDelay: `${(i + 1) * 100}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div
                    className={`w-12 h-12 rounded-xl ${tool.color} flex items-center justify-center shrink-0`}
                  >
                    <i className={`${tool.icon} text-xl text-white`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {tool.title}
                      </h3>
                      {tool.badge && (
                        <span className="inline-block bg-primary-100 text-primary-700 text-[10px] font-extrabold tracking-wider uppercase px-2 py-0.5 rounded-full whitespace-nowrap">
                          {tool.badge}
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                      {tool.desc}
                    </p>
                    <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:text-primary-500 transition-colors">
                      Otwórz kalkulator
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <h2 className="text-2xl font-bold text-foreground-950">Kalkulatory kredytowe: praktyczny punkt wyjścia</h2>
          <p className="mt-4 leading-7 text-foreground-600">Kalkulator zdolności kredytowej pomaga oszacować możliwą kwotę finansowania, a kalkulator nadpłaty pokazuje wpływ dodatkowych wpłat na czas i koszt kredytu. Kalkulator refinansowania oraz konsolidacji ułatwiają porównanie obecnej umowy z innym wariantem.</p>
          <p className="mt-4 leading-7 text-foreground-600">Wynik jest wstępny — po obliczeniu możesz go omówić z ekspertem kredytowym w Sanoku. Analiza oferty bankowej uwzględnia aktualne warunki oraz Twoją indywidualną sytuację.</p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
          <div className="bg-foreground-950 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
            <div className="absolute -right-20 -top-20 w-60 h-60 rounded-full bg-primary-500/10 blur-3xl pointer-events-none" />
            <div className="relative z-10">
              <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3">
                Kalkulatory to dopiero początek — ekspert kredytowy dobierze najlepszą ofertę
              </h2>
              <p className="text-sm text-white/60 max-w-xl mx-auto mb-8 leading-relaxed">
                Wyniki z kalkulatorów to świetny punkt wyjścia. Ekspert kredytowy zweryfikuje je w kilkunastu bankach, uwzględni pełne koszty i wynegocjuje lepsze warunki niż z tabeli.
              </p>
              <a
                href="tel:698084044"
                className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-white font-extrabold text-lg rounded-full hover:bg-primary-600 transition-all hover:-translate-y-0.5 shadow-lg shadow-primary-500/20 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl" />
                698 084 044
              </a>
              <div className="flex flex-wrap gap-5 justify-center mt-6">
                {[
                  'Bezpłatna konsultacja',
                  '153 oferty z 10 banków',
                  'Bez zobowiązań',
                ].map((t) => (
                  <span key={t} className="flex items-center gap-2 text-xs text-white/50">
                    <i className="ri-check-line text-green-400" />
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Legal */}
      <section className="pb-10 md:pb-14 bg-background-50">
        <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
          <p className="text-[11px] text-foreground-400 leading-relaxed text-center max-w-3xl mx-auto">
            Wszystkie kalkulatory mają charakter poglądowy i edukacyjny — nie stanowią oferty w rozumieniu art. 66 Kodeksu cywilnego, porady inwestycyjnej ani zapewnienia o udzieleniu kredytu. Ostateczne warunki zależą od indywidualnej oceny przez bank.
          </p>
        </div>
      </section>
    </div>
  );
}
